module.exports = __webpack_public_path__ + "img/services.56a82c2a.svg";